import {createAction, props} from '@ngrx/store';
import {IEntryForShow} from '../_interface/ientry-for-show';

export const loadEntries = createAction(
	'[Journal 📦 Entries] Loaded 👍',
	props<{ entries: IEntryForShow[] }>()
);

export const upsertOne = createAction(
	'[Journal 📦 Entries] Upsert one',
	props<{ entry: IEntryForShow }>()
);

export const clearEntries = createAction('[Journal 📦 Entries] Clear');
